import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-dark px-4 py-20" data-id="element-78" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-79" data-mp="9umi0wj5pw9e">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-alt shadow-sm" data-id="element-80" data-mp="9t1lx2h7259f">
          <ShieldCheckIcon className="h-8 w-8 text-brand-green" aria-hidden="true" data-id="element-81" data-mp="er35doij86lf" />
        </div>
        <h2 className="text-2xl font-black tracking-wide text-brand-deep md:text-3xl" data-id="element-82" data-mp="jqpuowbmxdal">
          🛡️ Get Your Money Back or Keep It.
        </h2>
        <p className="mt-6 leading-relaxed text-brand-gray" data-id="element-83" data-mp="skkox9b7xjbg">
          Try Biology Ready risk-free for 30 days. If it doesn&apos;t help you teach biology with more clarity and
          confidence, email us for a full refund — and keep the bonuses on us.
        </p>
      </Reveal>
    </section>;
}